import React, { useEffect, useLayoutEffect, useState } from 'react';
import { waitForRegisteredLoads } from '../../../utils/loadingRegistry';

const MIN_DISPLAY_MS = 1200;
const SAFETY_TIMEOUT_MS = 6000;
const SESSION_VISITED_KEY = 'raykana-splash-shown';

const waitForImages = () => {
  const pending = Array.from(document.images).filter(img => !img.complete);
  if (pending.length === 0) return Promise.resolve();
  return Promise.all(
    pending.map(img => new Promise(resolve => {
      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    }))
  );
};

const waitForFonts = () => (
  document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()
);

export const Loading = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [showBrand, setShowBrand] = useState(true);

  useLayoutEffect(() => {
    const alreadyVisited = sessionStorage.getItem(SESSION_VISITED_KEY);
    const isTopPage = window.location.pathname === '/';
    if (alreadyVisited && !isTopPage) {
      setShowBrand(false);
    }
    sessionStorage.setItem(SESSION_VISITED_KEY, '1');
  }, []);

  useEffect(() => {
    let cancelled = false;
    const ready = Promise.all([waitForImages(), waitForFonts(), waitForRegisteredLoads()]);
    const timeout = new Promise(resolve => setTimeout(resolve, SAFETY_TIMEOUT_MS));
    const minDisplay = new Promise(resolve => setTimeout(resolve, MIN_DISPLAY_MS));

    Promise.all([Promise.race([ready, timeout]), minDisplay]).then(() => {
      if (!cancelled) setIsLoaded(true);
    });

    return () => { cancelled = true; };
  }, []);

  return (
    <>
      <div
        aria-hidden={isLoaded}
        className={`fixed inset-0 z-[9999] flex items-center justify-center bg-black transition-opacity duration-500 ${isLoaded ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
      >
        {showBrand && (
          <span className="font-jost text-ink text-[40px] tracking-[3px]">RayKana</span>
        )}
      </div>
      {children}
    </>
  );
}
